import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/esnext.promise.all-settled.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.timers.js";
import { defineComponent as _defineComponent } from 'vue';
import { ref, computed, onMounted } from 'vue';
import { VBtn, VList, VListItem, VListItemContent, VListItemIcon, VListItemTitle, VMenu, VSkeletonLoader } from 'vuetify/lib';
import * as Constants from '@/constants';
import { BASE_MENU_ITEMS, NEWS_CATEGORIES_DIRECTORIES, NEWS_CATEGORY_MENU_ITEM, PUBLISHER_SUB_MENUS, SHOW_NEWS_PANEL_MENU_ITEM } from './site-menu-constants';
import { DocumentTypeEnum } from 'wklr-backend-sdk/models';
import { generateSearchRoute } from '@/utils/routeUtils';
import { scrollToTop } from '@/utility';
import { useDomain } from '@/plugins/domain';
import { useRepositories } from '@/plugins/repositories';
import { useStore } from '@/store/useStore';
import { useToast } from '@/plugins/vueToast';
import { useAuth } from '@/plugins/auth';
import AccountMenuList from '@/components/renewal/header/account-menu-list.vue';
import HelpMenuList from '@/components/renewal/header/help-menu-list.vue';
import Icon from '@/components/renewal/common/icon.vue';
import SiteMenuHistory from '@/components/renewal/header/site-menu-history.vue';
import SiteMenuSub from '@/components/renewal/header/site-menu-sub.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'site-menu',
  setup: function setup(__props) {
    var router = useRouter();
    var domain = useDomain();
    var $repositories = useRepositories();
    var toast = useToast();
    var auth = useAuth();

    // =================
    // メニュー
    // =================
    var isShowMenu = ref(false);

    // アニメーション用
    var animationDuration = 300;
    var isSubMenuShowing = ref(false);
    var isSubMenuHiding = ref(false);
    var startShowingSubMenu = function startShowingSubMenu(callback) {
      isSubMenuShowing.value = true;
      setTimeout(function () {
        isSubMenuShowing.value = false;
      }, animationDuration);

      // アニメーションさせるために少し待つ
      setTimeout(callback, 100);
    };
    var startHidingSubMenu = function startHidingSubMenu(callback) {
      isSubMenuHiding.value = true;
      setTimeout(function () {
        isSubMenuHiding.value = false;
      }, animationDuration);

      // アニメーションさせるために少し待つ
      setTimeout(callback, 100);
    };
    var handleMenuTriggerClick = function handleMenuTriggerClick() {
      isShowMenu.value = !isShowMenu.value;
      resetSelectedMenuItem();
    };
    var handleOutsideClick = function handleOutsideClick(updatedIsShowMenu) {
      isShowMenu.value = updatedIsShowMenu;
      resetSelectedMenuItem();
    };
    var resetSelectedMenuItem = function resetSelectedMenuItem() {
      selectedMenuItem.value = null;
    };
    var backToBeforeMenu = function backToBeforeMenu() {
      startHidingSubMenu(resetSelectedMenuItem);
    };
    var selectedMenuItem = ref(null);
    var menuItems = computed(function () {
      var _items = _toConsumableArray(BASE_MENU_ITEMS);
      var oid = auth.user.organization.oid;
      if (auth.permissions.practiceArea) {
        _items.unshift(NEWS_CATEGORY_MENU_ITEM);
      }
      if (oid === 'legalscape' || oid === 'preview_basic' || oid === 'd1_preview') {
        _items.push(SHOW_NEWS_PANEL_MENU_ITEM);
      }
      return _items;
    });
    var menuItemsCountsLoading = ref(false);
    var menuItemsCounts = ref({
      newsCategory: null,
      publisher: null,
      format: null,
      guideline: null,
      publicComment: null
    });

    // それぞれの全数
    var getMenuItemsCounts = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var countsPromises, _yield$Promise$allSet, _yield$Promise$allSet2, newsCategoriesCount, publishersCount, formatCategoriesCount, guidelinesCount, publicCommentsCount, handleResponse;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              menuItemsCountsLoading.value = true;
              countsPromises = [$repositories.news.getNewsCount(), $repositories.books.getCount(), $repositories.format.getFormatFileCount(), $repositories.guidelines.getCount(), $repositories.publicComments.getCount()];
              _context.next = 4;
              return Promise.allSettled(countsPromises);
            case 4:
              _yield$Promise$allSet = _context.sent;
              _yield$Promise$allSet2 = _slicedToArray(_yield$Promise$allSet, 5);
              newsCategoriesCount = _yield$Promise$allSet2[0];
              publishersCount = _yield$Promise$allSet2[1];
              formatCategoriesCount = _yield$Promise$allSet2[2];
              guidelinesCount = _yield$Promise$allSet2[3];
              publicCommentsCount = _yield$Promise$allSet2[4];
              handleResponse = function handleResponse(key, res) {
                var isFulFilled = res.status === 'fulfilled';
                if (isFulFilled) {
                  menuItemsCounts.value[key] = res.value;
                  return;
                }
                console.error(res.reason);
              };
              handleResponse('newsCategory', newsCategoriesCount);
              handleResponse('publisher', publishersCount);
              handleResponse('format', formatCategoriesCount);
              handleResponse('guideline', guidelinesCount);
              handleResponse('publicComment', publicCommentsCount);
              menuItemsCountsLoading.value = false;
            case 18:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function getMenuItemsCounts() {
        return _ref.apply(this, arguments);
      };
    }();

    // メニュー各項目内のコンテンツおよび key 別カウントの取得
    var menuItemActions = {
      newsCategory: function newsCategory() {
        if (newsCategories.value === null) {
          getNewsCategories();
        }
        if (subMenuCounts.value.newsCategory === null) {
          getNewsCategoryCounts();
        }
      },
      publisher: function publisher() {
        if (publishers.value === null) {
          getPublishers();
        }
        if (subMenuCounts.value.publisher === null) {
          getPublisherCounts();
        }

        // 購入済み書籍のカウントはサブメニューを開くたびに取得する
        getPurchasedDocumentsCount();
      },
      format: function format() {
        if (formatCategories.value === null) {
          getFormatCategories();
        }
        if (subMenuCounts.value.format === null) {
          getFormatCategoryCounts();
        }
      },
      guideline: function guideline() {
        if (guidelines.value === null) {
          getGuidelines();
        }
        if (subMenuCounts.value.guideline === null) {
          getGuidelineCounts();
        }
      },
      publicComment: function publicComment() {
        if (publicComments.value === null) {
          getPublicComments();
        }
        if (subMenuCounts.value.publicComment === null) {
          getPublicCommentCounts();
        }
      },
      collection: function collection() {
        isShowMenu.value = false;
        router.push('/collections');
      },
      history: function history() {
        // 履歴はサブメニューを開くたびに取得する
        getHistories();
      },
      announce: function announce() {
        isShowMenu.value = false;
        window.open('https://announcekit.co/legalscape/legalscape', '_blank', 'noopener,noreferrer');
      },
      showNewsPanel: function showNewsPanel() {
        isShowMenu.value = false;
        var showNewsPanel = store.state.persistent.showNewsPanel;
        store.commit('setShowNewsPanel', !showNewsPanel);
      }
    };
    var handleMenuItemClick = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(key) {
        var animationTargets;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(selectedMenuItem.value === key)) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return");
            case 2:
              animationTargets = [].concat(_toConsumableArray(Object.keys(subMenus.value)), ['history', 'account', 'help']);
              if (animationTargets.includes(key)) {
                startShowingSubMenu(function () {
                  selectedMenuItem.value = key;
                });
              }
              if (key in menuItemActions) {
                menuItemActions[key]();
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function handleMenuItemClick(_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(function () {
      getMenuItemsCounts();
    });

    // =================
    // サブメニュー
    // =================
    // 共通
    var formatSubMenusCounts = function formatSubMenusCounts(counts) {
      return counts.reduce(function (acc, cur) {
        acc[cur.key] = cur;
        return acc;
      }, {});
    };

    // 検索ページへの遷移に関する処理
    var store = useStore();
    var routeChanging = computed(function () {
      return store.state.global.routeChanging;
    });
    var storedPerPage = computed(function () {
      return store.state.persistent.perPage;
    });
    var storedOrderId = computed(function () {
      return store.state.search.orderId;
    });
    var storedOption = computed(function () {
      return {
        n: storedPerPage.value || Constants.Search.PerPage,
        o: storedOrderId.value || Constants.Search.OrderId
      };
    });
    var goToSearchPage = function goToSearchPage(documentType, publisher) {
      if (routeChanging.value) {
        return;
      }

      // SERP以外では詳細検索が画面に表示されていないので、以下をデフォルトとして検索する
      var query = {
        keyword: '',
        type: [documentType],
        publisher: [publisher],
        maxGaps: Constants.Search.DefaultMaxGaps,
        includeOlderEditions: false
      };
      var to = generateSearchRoute(query, storedOption.value);

      // 画面上部にスクロールする
      scrollToTop();
      router.push(to);
    };

    // ニュースカテゴリ
    var loadingNewsCategories = ref(false);
    var newsCategories = ref(null);
    var formattedNewsCategories = computed(function () {
      var _newsCategories$value;
      var list = (_newsCategories$value = newsCategories.value) === null || _newsCategories$value === void 0 ? void 0 : _newsCategories$value.map(function (category) {
        return {
          title: category.name,
          value: NEWS_CATEGORIES_DIRECTORIES[category.name]
        };
      });
      return list || [];
    });
    var getNewsCategories = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              loadingNewsCategories.value = true;
              _context3.prev = 1;
              _context3.next = 4;
              return $repositories.users.getUserNewsCategories();
            case 4:
              res = _context3.sent;
              newsCategories.value = res.newsCategories;
              _context3.next = 11;
              break;
            case 8:
              _context3.prev = 8;
              _context3.t0 = _context3["catch"](1);
              toast.error('ニュースカテゴリの取得に失敗しました');
            case 11:
              loadingNewsCategories.value = false;
            case 12:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[1, 8]]);
      }));
      return function getNewsCategories() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getNewsCategoryCounts = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var counts;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 3;
              return $repositories.news.getNewsCountByCategory();
            case 3:
              counts = _context4.sent;
              subMenuCounts.value.newsCategory = formatSubMenusCounts(counts);
              _context4.next = 10;
              break;
            case 7:
              _context4.prev = 7;
              _context4.t0 = _context4["catch"](0);
              console.error(_context4.t0);
            case 10:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 7]]);
      }));
      return function getNewsCategoryCounts() {
        return _ref4.apply(this, arguments);
      };
    }();
    var handleNewsCategoryClick = function handleNewsCategoryClick(value) {
      var path = value === 'all' ? '/directories' : "/directories/".concat(value);
      router.push(path);
    };

    // 書籍・雑誌
    var loadingPublishers = ref(false);
    var publishers = ref(null);
    var formattedPublishers = computed(function () {
      var _publishers$value;
      var list = (_publishers$value = publishers.value) === null || _publishers$value === void 0 ? void 0 : _publishers$value.map(function (publisher) {
        return {
          title: publisher,
          value: publisher
        };
      });
      return [].concat(_toConsumableArray(PUBLISHER_SUB_MENUS), _toConsumableArray(list || []));
    });
    var getPublishers = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              loadingPublishers.value = true;
              _context5.prev = 1;
              _context5.next = 4;
              return $repositories.publishers.listPublisherNames(DocumentTypeEnum.Book);
            case 4:
              publishers.value = _context5.sent;
              _context5.next = 10;
              break;
            case 7:
              _context5.prev = 7;
              _context5.t0 = _context5["catch"](1);
              toast.error('書籍・雑誌の取得に失敗しました');
            case 10:
              loadingPublishers.value = false;
            case 11:
            case "end":
              return _context5.stop();
          }
        }, _callee5, null, [[1, 7]]);
      }));
      return function getPublishers() {
        return _ref5.apply(this, arguments);
      };
    }();
    var getPublisherCounts = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var counts;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return $repositories.books.getCountByPublisher();
            case 3:
              counts = _context6.sent;
              subMenuCounts.value.publisher = _objectSpread(_objectSpread({}, subMenuCounts.value.publisher), formatSubMenusCounts(counts));
              _context6.next = 10;
              break;
            case 7:
              _context6.prev = 7;
              _context6.t0 = _context6["catch"](0);
              console.error(_context6.t0);
            case 10:
            case "end":
              return _context6.stop();
          }
        }, _callee6, null, [[0, 7]]);
      }));
      return function getPublisherCounts() {
        return _ref6.apply(this, arguments);
      };
    }();
    var getPurchasedDocumentsCount = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var _yield$$repositories$, count;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.prev = 0;
              _context7.next = 3;
              return $repositories.users.purchasedDocumentsCount();
            case 3:
              _yield$$repositories$ = _context7.sent;
              count = _yield$$repositories$.count;
              subMenuCounts.value.publisher = _objectSpread(_objectSpread({}, subMenuCounts.value.publisher), {}, {
                購入済み書籍: {
                  key: '購入済み書籍',
                  count: count
                }
              });
              _context7.next = 11;
              break;
            case 8:
              _context7.prev = 8;
              _context7.t0 = _context7["catch"](0);
              console.error(_context7.t0);
            case 11:
            case "end":
              return _context7.stop();
          }
        }, _callee7, null, [[0, 8]]);
      }));
      return function getPurchasedDocumentsCount() {
        return _ref7.apply(this, arguments);
      };
    }();
    var handlePublisherClick = function handlePublisherClick(value) {
      var isRoutePath = value.startsWith('/');
      if (isRoutePath) {
        router.push(value);
        return;
      }
      goToSearchPage(DocumentTypeEnum.Book, value);
    };

    // 書式ファイル
    var loadingFormatCategories = ref(false);
    var formatCategories = ref(null);
    var formattedFormatCategories = computed(function () {
      var _formatCategories$val;
      var list = (_formatCategories$val = formatCategories.value) === null || _formatCategories$val === void 0 ? void 0 : _formatCategories$val.map(function (formatCategory) {
        return {
          title: formatCategory.name,
          value: String(formatCategory.id)
        };
      });
      return list || [];
    });
    var getFormatCategories = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              loadingFormatCategories.value = true;
              _context8.prev = 1;
              _context8.next = 4;
              return $repositories.format.getCategories();
            case 4:
              formatCategories.value = _context8.sent;
              _context8.next = 10;
              break;
            case 7:
              _context8.prev = 7;
              _context8.t0 = _context8["catch"](1);
              toast.error('書式ファイルの取得に失敗しました');
            case 10:
              loadingFormatCategories.value = false;
            case 11:
            case "end":
              return _context8.stop();
          }
        }, _callee8, null, [[1, 7]]);
      }));
      return function getFormatCategories() {
        return _ref8.apply(this, arguments);
      };
    }();
    var getFormatCategoryCounts = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _yield$$repositories$2, counts;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _context9.prev = 0;
              _context9.next = 3;
              return $repositories.format.getFormatCategoriesCount();
            case 3:
              _yield$$repositories$2 = _context9.sent;
              counts = _yield$$repositories$2.counts;
              subMenuCounts.value.format = formatSubMenusCounts(counts);
              _context9.next = 11;
              break;
            case 8:
              _context9.prev = 8;
              _context9.t0 = _context9["catch"](0);
              console.error(_context9.t0);
            case 11:
            case "end":
              return _context9.stop();
          }
        }, _callee9, null, [[0, 8]]);
      }));
      return function getFormatCategoryCounts() {
        return _ref9.apply(this, arguments);
      };
    }();
    var handleFormatCategoryClick = function handleFormatCategoryClick(categoryId, subcategoryTitle) {
      var path = "/format/categories/".concat(categoryId, "/subcategories");
      if (subcategoryTitle) {
        path += "#".concat(subcategoryTitle);
      }
      router.push(path);
    };

    // ガイドライン
    var loadingGuidelines = ref(false);
    var guidelines = ref(null);
    var formattedGuidelines = computed(function () {
      var _guidelines$value;
      var list = (_guidelines$value = guidelines.value) === null || _guidelines$value === void 0 ? void 0 : _guidelines$value.map(function (guideline) {
        return {
          title: guideline,
          value: guideline
        };
      });
      return list || [];
    });
    var getGuidelines = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              loadingGuidelines.value = true;
              _context10.prev = 1;
              _context10.next = 4;
              return $repositories.publishers.listPublisherNames(DocumentTypeEnum.Guideline);
            case 4:
              guidelines.value = _context10.sent;
              _context10.next = 10;
              break;
            case 7:
              _context10.prev = 7;
              _context10.t0 = _context10["catch"](1);
              toast.error('ガイドラインの取得に失敗しました');
            case 10:
              loadingGuidelines.value = false;
            case 11:
            case "end":
              return _context10.stop();
          }
        }, _callee10, null, [[1, 7]]);
      }));
      return function getGuidelines() {
        return _ref10.apply(this, arguments);
      };
    }();
    var getGuidelineCounts = /*#__PURE__*/function () {
      var _ref11 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var counts;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.prev = 0;
              _context11.next = 3;
              return $repositories.guidelines.getCountByPublisher();
            case 3:
              counts = _context11.sent;
              subMenuCounts.value.guideline = formatSubMenusCounts(counts);
              _context11.next = 10;
              break;
            case 7:
              _context11.prev = 7;
              _context11.t0 = _context11["catch"](0);
              console.error(_context11.t0);
            case 10:
            case "end":
              return _context11.stop();
          }
        }, _callee11, null, [[0, 7]]);
      }));
      return function getGuidelineCounts() {
        return _ref11.apply(this, arguments);
      };
    }();
    var handleGuidelineClick = function handleGuidelineClick(value) {
      goToSearchPage(DocumentTypeEnum.Guideline, value);
    };

    // パブコメ
    var loadingPublicComments = ref(false);
    var publicComments = ref(null);
    var formattedPublicComments = computed(function () {
      var _publicComments$value;
      var list = (_publicComments$value = publicComments.value) === null || _publicComments$value === void 0 ? void 0 : _publicComments$value.map(function (publicComment) {
        return {
          title: publicComment,
          value: publicComment
        };
      });
      return list !== null && list !== void 0 ? list : [];
    });
    var getPublicComments = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              loadingPublicComments.value = true;
              _context12.prev = 1;
              _context12.next = 4;
              return $repositories.publishers.listPublisherNames(DocumentTypeEnum.Pubcom);
            case 4:
              publicComments.value = _context12.sent;
              _context12.next = 10;
              break;
            case 7:
              _context12.prev = 7;
              _context12.t0 = _context12["catch"](1);
              toast.error('パブコメの取得に失敗しました');
            case 10:
              loadingPublicComments.value = false;
            case 11:
            case "end":
              return _context12.stop();
          }
        }, _callee12, null, [[1, 7]]);
      }));
      return function getPublicComments() {
        return _ref12.apply(this, arguments);
      };
    }();
    var getPublicCommentCounts = /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee13() {
        var counts;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) switch (_context13.prev = _context13.next) {
            case 0:
              _context13.prev = 0;
              _context13.next = 3;
              return $repositories.publicComments.getCountByPublisher();
            case 3:
              counts = _context13.sent;
              subMenuCounts.value.publicComment = formatSubMenusCounts(counts);
              _context13.next = 10;
              break;
            case 7:
              _context13.prev = 7;
              _context13.t0 = _context13["catch"](0);
              console.error(_context13.t0);
            case 10:
            case "end":
              return _context13.stop();
          }
        }, _callee13, null, [[0, 7]]);
      }));
      return function getPublicCommentCounts() {
        return _ref13.apply(this, arguments);
      };
    }();
    var handlePublicCommentClick = function handlePublicCommentClick(value) {
      goToSearchPage(DocumentTypeEnum.Pubcom, value);
    };
    var subMenus = computed(function () {
      return {
        newsCategory: formattedNewsCategories.value,
        publisher: formattedPublishers.value,
        format: formattedFormatCategories.value,
        guideline: formattedGuidelines.value,
        publicComment: formattedPublicComments.value
      };
    });
    var subMenuLoadings = computed(function () {
      return {
        newsCategory: loadingNewsCategories.value,
        publisher: loadingPublishers.value,
        format: loadingFormatCategories.value,
        guideline: loadingGuidelines.value,
        publicComment: loadingPublicComments.value
      };
    });
    var subMenuCounts = ref({
      newsCategory: null,
      publisher: null,
      format: null,
      guideline: null,
      publicComment: null
    });
    var handleSubMenuItemClick = function handleSubMenuItemClick(key, subItem) {
      var _subItem$value, _subItem$value2, _subItem$value3, _subItem$value4, _subItem$value5;
      switch (key) {
        case 'newsCategory':
          handleNewsCategoryClick((_subItem$value = subItem.value) !== null && _subItem$value !== void 0 ? _subItem$value : '');
          break;
        case 'publisher':
          handlePublisherClick((_subItem$value2 = subItem.value) !== null && _subItem$value2 !== void 0 ? _subItem$value2 : '');
          break;
        case 'format':
          handleFormatCategoryClick((_subItem$value3 = subItem.value) !== null && _subItem$value3 !== void 0 ? _subItem$value3 : '');
          break;
        case 'guideline':
          handleGuidelineClick((_subItem$value4 = subItem.value) !== null && _subItem$value4 !== void 0 ? _subItem$value4 : '');
          break;
        case 'publicComment':
          handlePublicCommentClick((_subItem$value5 = subItem.value) !== null && _subItem$value5 !== void 0 ? _subItem$value5 : '');
          break;
        default:
          break;
      }
      isShowMenu.value = false;
    };

    // =================
    // 履歴
    // =================
    var isHistoriesLoading = ref(false);
    var histories = ref([]);
    var getHistories = /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee14() {
        var historyOffset, nToShow, _yield$Promise$all, _yield$Promise$all2, docs, searches, sortedHistory;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.prev = 0;
              isHistoriesLoading.value = true;
              historyOffset = 0; // 履歴データをfromいくつから取得すればよいか
              nToShow = Constants.Portal.PerPage;
              _context14.next = 6;
              return Promise.all([$repositories.histories.getDocHistories(historyOffset, nToShow), $repositories.histories.getSearchHistories(historyOffset, nToShow)]);
            case 6:
              _yield$Promise$all = _context14.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              docs = _yield$Promise$all2[0];
              searches = _yield$Promise$all2[1];
              // 結合したものを時系列順に並べるのは本来は間違っている。
              // (そもそもユーザーの "一連の" 行動を記録するということを目的としたデータの採取を考える必要がある。)
              sortedHistory = [].concat(_toConsumableArray(docs.excerpt), _toConsumableArray(searches.excerpt)).sort(function (a, b) {
                return b.timeStamp.localeCompare(a.timeStamp);
              });
              histories.value = sortedHistory.slice(0, nToShow);
              _context14.next = 17;
              break;
            case 14:
              _context14.prev = 14;
              _context14.t0 = _context14["catch"](0);
              console.error(_context14.t0);
            case 17:
              _context14.prev = 17;
              isHistoriesLoading.value = false;
              return _context14.finish(17);
            case 20:
            case "end":
              return _context14.stop();
          }
        }, _callee14, null, [[0, 14, 17, 20]]);
      }));
      return function getHistories() {
        return _ref14.apply(this, arguments);
      };
    }();
    var disablePersonalFeature = computed(function () {
      return domain.isMHMMypage;
    });
    var handleHistoryAnchorClick = function handleHistoryAnchorClick() {
      isShowMenu.value = false;
    };
    return {
      __sfc: true,
      router: router,
      domain: domain,
      $repositories: $repositories,
      toast: toast,
      auth: auth,
      isShowMenu: isShowMenu,
      animationDuration: animationDuration,
      isSubMenuShowing: isSubMenuShowing,
      isSubMenuHiding: isSubMenuHiding,
      startShowingSubMenu: startShowingSubMenu,
      startHidingSubMenu: startHidingSubMenu,
      handleMenuTriggerClick: handleMenuTriggerClick,
      handleOutsideClick: handleOutsideClick,
      resetSelectedMenuItem: resetSelectedMenuItem,
      backToBeforeMenu: backToBeforeMenu,
      selectedMenuItem: selectedMenuItem,
      menuItems: menuItems,
      menuItemsCountsLoading: menuItemsCountsLoading,
      menuItemsCounts: menuItemsCounts,
      getMenuItemsCounts: getMenuItemsCounts,
      menuItemActions: menuItemActions,
      handleMenuItemClick: handleMenuItemClick,
      formatSubMenusCounts: formatSubMenusCounts,
      store: store,
      routeChanging: routeChanging,
      storedPerPage: storedPerPage,
      storedOrderId: storedOrderId,
      storedOption: storedOption,
      goToSearchPage: goToSearchPage,
      loadingNewsCategories: loadingNewsCategories,
      newsCategories: newsCategories,
      formattedNewsCategories: formattedNewsCategories,
      getNewsCategories: getNewsCategories,
      getNewsCategoryCounts: getNewsCategoryCounts,
      handleNewsCategoryClick: handleNewsCategoryClick,
      loadingPublishers: loadingPublishers,
      publishers: publishers,
      formattedPublishers: formattedPublishers,
      getPublishers: getPublishers,
      getPublisherCounts: getPublisherCounts,
      getPurchasedDocumentsCount: getPurchasedDocumentsCount,
      handlePublisherClick: handlePublisherClick,
      loadingFormatCategories: loadingFormatCategories,
      formatCategories: formatCategories,
      formattedFormatCategories: formattedFormatCategories,
      getFormatCategories: getFormatCategories,
      getFormatCategoryCounts: getFormatCategoryCounts,
      handleFormatCategoryClick: handleFormatCategoryClick,
      loadingGuidelines: loadingGuidelines,
      guidelines: guidelines,
      formattedGuidelines: formattedGuidelines,
      getGuidelines: getGuidelines,
      getGuidelineCounts: getGuidelineCounts,
      handleGuidelineClick: handleGuidelineClick,
      loadingPublicComments: loadingPublicComments,
      publicComments: publicComments,
      formattedPublicComments: formattedPublicComments,
      getPublicComments: getPublicComments,
      getPublicCommentCounts: getPublicCommentCounts,
      handlePublicCommentClick: handlePublicCommentClick,
      subMenus: subMenus,
      subMenuLoadings: subMenuLoadings,
      subMenuCounts: subMenuCounts,
      handleSubMenuItemClick: handleSubMenuItemClick,
      isHistoriesLoading: isHistoriesLoading,
      histories: histories,
      getHistories: getHistories,
      disablePersonalFeature: disablePersonalFeature,
      handleHistoryAnchorClick: handleHistoryAnchorClick,
      VBtn: VBtn,
      VList: VList,
      VListItem: VListItem,
      VListItemContent: VListItemContent,
      VListItemIcon: VListItemIcon,
      VListItemTitle: VListItemTitle,
      VMenu: VMenu,
      VSkeletonLoader: VSkeletonLoader,
      AccountMenuList: AccountMenuList,
      HelpMenuList: HelpMenuList,
      Icon: Icon,
      SiteMenuHistory: SiteMenuHistory,
      SiteMenuSub: SiteMenuSub
    };
  }
});